import Section from 'components/Section'
import { buildTranslate } from 'locales'
import React from 'react'
import { useSelector } from 'react-redux'
import { getExtension } from 'scenes/Cms/helper'
import { selectApp } from 'selectors/app'
import Header from '../../components/Header'
import Asset from '../Asset'
import ImageAsset from '../ImageAsset'

const t = buildTranslate('cms.brand.app_store_assets')

const AppStoreHeader = () => {
  const app = useSelector(selectApp)

  if (!app) return null

  const { ios_header_image_urls: image } = app

  return (
    <Section className="p-xl mt-l">
      <Header title={t('app_store_header.title')} />
      <Asset
        className="mt-s"
        description={t('app_store_header.description')}
        badges={[t('app_store_header.size'), getExtension(image?.small)]}
      >
        <ImageAsset width="180px" height="77px" image={image?.small} />
      </Asset>
    </Section>
  )
}

export default AppStoreHeader
